export const LAST_PCT_KEY = 'six:todo:lastPct'
export const ANIM_DURATION_MS = 650
export const STORAGE_TYPE = 'local' // 'local' or 'session' if you want to change
